import {ITeamEnvironment} from "./environment.interface";
import {Brands} from "@server-models";

export const environment: ITeamEnvironment = {
  production: false,
  brand: Brands.Semco,
  apiUrl: {
    one: "http://localhost:8100",
    pageDefaultSize: 50,
    defaultTimeoutSec: 30,
    tokenExpireOffsetSec: 30
  },
  lang: {
    defaultLanguage: "de-DE",
    isUseBrowserLanguage: false
  },
};
